import type { BlokProps } from "@trydig/storyblok";
import { clsx, Slot } from "@trydig/ui";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Container } from "@/components/ui/Container";
import type { BlokMediaFrame } from "@/storyblok";
import { AssetBlok, sizes } from "../Asset";
import styles from "./MediaFrame.module.css";

export const MediaFrameBlok = ({
	blok,
	"data-priority": priority,
}: BlokProps<BlokMediaFrame> & {
	"data-priority"?: boolean;
}) => {
	const dualSize = !!blok.source_2?.length;
	const sizing = dualSize ? sizes(50, 50) : sizes(100, 80);
	const isFullWidth = blok.fullWidth ?? true;

	const Wrapper = isFullWidth ? Slot : Container;

	return (
		<BlokWrap editable={blok} asChild>
			<Wrapper>
				<section
					className={clsx(styles.root, !!blok.source_2?.length && styles.dual)}
				>
					{blok.title && <span className={styles.title}>{blok.title}</span>}
					<div className={styles.media}>
						<div className={styles.sourceContainer}>
							<AssetBlok
								priority={priority}
								sizes={sizing}
								source={blok.source}
								soundControlLight={blok.lightMode}
							/>
						</div>
						{!!blok.source_2?.length && (
							<div className={styles.sourceContainer2}>
								<AssetBlok
									priority={priority}
									sizes={sizing}
									source={blok.source_2}
									soundControlLight={blok.lightMode}
								/>
							</div>
						)}
					</div>
					<div className={styles.bg} />
				</section>
			</Wrapper>
		</BlokWrap>
	);
};
